/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Grid_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Display Grid Settings" |
*
* @param {Options_Display_Grid_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_grid_settings_title = /** @type {((inputs?: Options_Display_Grid_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Grid_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de la grille d'affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rastereinstellungen anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni griglia di visualizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки отображения сетки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de la cuadrícula de visualización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示网格设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グリッド設定を表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ग्रिड सेटिंग्स प्रदर्शित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações da grade de exibição")
	return /** @type {LocalizedString} */ ("Display Grid Settings")
});